import { TimeRange } from "../types/TimeRange";

export const DEFAULT_WORKING_HOURS_TIME_RANGE: TimeRange = {
	start: "07:00",
	end: "17:00",
};
